import { AvailablePlansTypes } from '@constants/plans'
import { useGetPlanFeatures } from '@pages/Checkout/hooks/useGetPlanFeatures'
import {
  Heading,
  Icon,
  List,
  Paragraph,
  Spacer,
  Spreader,
  Tooltip
} from '@ui-kit'
import { FC, Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Row } from 'simple-flexbox'
import { v4 as uuidv4 } from 'uuid'

interface FeaturesProps {
  recordKey: AvailablePlansTypes
}

export const Features: FC<FeaturesProps> = ({ recordKey }) => {
  const { t } = useTranslation()

  const features = useGetPlanFeatures({ recordKey })

  return (
    <Fragment>
      <Heading level={5} color='neutral-6'>
        {t('plans.another.features')}
      </Heading>

      <Spacer space={5} />

      <List>
        {features.map(({ name, tooltip }) => (
          <Fragment key={uuidv4()}>
            <Row vertical='baseline'>
              <Icon icon='icon-ok' size={14} />

              <Spreader spread={10} />

              <Tooltip content={tooltip} disabled={!tooltip}>
                <Paragraph>
                  {name}

                  {tooltip ? (
                    <Fragment>
                      <Spreader spread={5} />

                      <Icon
                        icon='icon-help_outline'
                        size={12}
                        color='neutral-4'
                      />
                    </Fragment>
                  ) : null}
                </Paragraph>
              </Tooltip>
            </Row>

            <Spacer space={5} />
          </Fragment>
        ))}
      </List>
    </Fragment>
  )
}

Features.displayName = 'CheckoutPlansPlanFeatures'
